export default {
    order(state) {
        return state.order;
    },
    currentStep(state) {
        return state.order.service.steps[state.currentStep];
    },
    fieldValue: (state) => (blockId) => {
        let block = state.blocks.find(block => block.id == blockId);
        if (block && block.data) {
            return block.data.value;
        }
        return null;
    },
    fieldValidationStatus: (state) => (blockId) => {
        return state.blocks.find(block => block.id == blockId).isValid;
    },

    fieldError: (state) => (blockId) => {
        return state.blocks.find(block => block.id == blockId).errorMessages;
    },

    orderMode(state) {
        return (state.order) ? state.order.mode : null;
    }
}